import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUpdatePpis } from '../actions';
import { getIsFetching, getPpisUpdates } from '../selectors';
// import { getIsLocalUser } from '../../loginSystem/selectors';

const usePpisUpdates = ({} = {}) => {
  const dispatch = useDispatch();
  const isFetching = useSelector(getIsFetching);
  const updatePpis = useSelector(getPpisUpdates);
  // const isLocalUser = useSelector(getIsLocalUser);

  useEffect(() => {
    dispatch(fetchUpdatePpis());
  }, [dispatch]);

  return [isFetching, updatePpis];
};

export default usePpisUpdates;
